import { fileTypeToExtension, getMimeTypeFromExtension } from '@doss/common-all'
import { DocumentType } from '../generated/apollo-operations'

/**
 * Get the react-dropzone accept prop for the document types passed in
 */
export const getDropzoneAcceptOptionForDocumentTypes = (acceptedDocumentTypes: DocumentType[]) => {
  return acceptedDocumentTypes.reduce((acc, documentType) => {
    const extension = fileTypeToExtension[documentType]
    return { ...acc, [getMimeTypeFromExtension(extension)]: [`.${extension}`] }
  }, {})
}

/**
 * Get the react-dropzone accept prop for all document types
 */
export const getDropzoneAcceptOptionForAllDocumentTypes = () => {
  const documentTypes = Object.values(DocumentType)
  return getDropzoneAcceptOptionForDocumentTypes(documentTypes)
}
